<template>
    <div class="message-input-container d-flex flex-column">
        <div class="row g-0 w-100">
            <div class="message-input-input col-md-3 col-sm-4" :class="{'invalid': (v$.$dirty && v$.messageClaim.$invalid)}" v-show="mode === 'all'">
                <input type="text" class="form-control" v-model="messageClaim" ref="input" :placeholder="$t('message.item.claim_number')" />
            </div>
            <div class="message-input-input col-md-6 col-sm-4" :class="{'w-100': mode !== 'all'}">
                <input type="text" class="form-control" v-model="messageSubject" ref="input" :placeholder="$t('message.item.subject')" />
            </div>
            <div class="message-input-input col-md-3 col-sm-4" :class="{'invalid': (v$.$dirty && v$.messageHotel.$invalid)}"  v-show="mode === 'all'">
                <form-dropdown :init-items="hotels" v-model="messageHotel" only-item-auto-select first-item-auto-select is-search :notSelectedLabel="$t('message.filter.select_value')" />
            </div>
        </div>
        <div class="d-flex align-items-center w-100">
            <div class="pe-3 ps-3 message-input-dropdown">
                <claim-chat-dropdown :items="messageTypes" v-model="messageType" v-model:type="messageTypeName" />
            </div>
            <div class="message-input-input flex-fill" :class="{'invalid': (v$.$dirty && v$.messageText.$invalid)}">
                <input type="text" class="form-control"  v-model="messageText" ref="input" :placeholder="$t('message.item.message')" />
            </div>
            <div class="message-input-button">
                <base-button @click-event ="sendMessage()" icon="paper-plane" v-model="loaderButton" :mobile-not-text="true"
                    :text="$t('message.item.send')" />
            </div>
        </div>
    </div>
</template>

<script>
import ClaimChatDropdown from 'components/chat/ClaimChatDropdown.vue';
import FormDropdown from 'components/form/Dropdown.vue';
import BaseButton from 'components/ui/BaseButton.vue';
import { mapState } from 'vuex'
import { useVuelidate } from '@vuelidate/core'
import { required, integer, maxLength } from '@vuelidate/validators'

export default {
    name: 'MessageInput',
    computed: {
        ...mapState({
            hotels: state => state.messages.hotels,
            messages: state => state.messages.messages,
            loading: state => state.messages.loading,
            isEmptyMessages: state => state.messages.isEmptyMessages,
            messagesInfo: state => state.messages.messagesInfo
        }),
    },
    props: {
        mode: {
            type: String,
            default: 'all'
        }
    },
    data() {
        return {
            v$: useVuelidate(),
            loaderButton: false,
            messageText: '',
            messageType: 4,
            messageClaim: null,
            messageSubject: null,
            messageHotel: null,
            messageTypeName: 'message',
            messageTypes: [
                {
                    label: this.$t('message.item.message'),
                    value: 4,
                    type: 'message',
                    color: 'var(--bs-purple)'
                },
                {
                    label: this.$t('message.item.information'),
                    value: 3,
                    type: 'information',
                    color: 'var(--bs-primary)'
                },
                {
                    label: this.$t('message.item.congratulation'),
                    value: 5,
                    type: 'congratulation',
                    color: 'var(--bs-green)'
                },
                {
                    label: this.$t('message.item.urgent'),
                    value: 1,
                    type: 'urgent',
                    color: 'var(--bs-yellow)'
                },
                {
                    label: this.$t('message.item.exclamation'),
                    value: 2,
                    type: 'important',
                    color: 'var(--bs-red)'
                },
            ],
        }
    },
    validations: {
        messageText: {
            required
        },
        messageClaim: {
            required
        },
        messageHotel: {
            required
        },
    },
    methods: {
        sendMessage() {

            this.v$.$validate();
            if (this.v$.$invalid) {
                return;
            }

            this.loaderButton = true;
            const params = {
                claim_id: this.messageClaim,
                hotel_id: this.messageHotel,
                type: this.messageType,
                subject: this.messageSubject,
                message: this.messageText
            };

            const self = this;

            this.$store.dispatch('messages/sendMessage', params).then((message)=>{
                const filter = self.$parent.$parent.$refs.filter;
                filter.hotel_id = this.messageHotel;

                self.messageClaim = '';
                self.messageText = '';
                self.messageSubject = '';
                self.messageType = 4;
                self.loaderButton = false;
                
                filter.search();

                this.v$.$reset();
            }).catch(() => {
                self.loaderButton = false;
            });
        },
        getSelectClass(type) {
            switch (type) {
                case 1:
                    return 'select-green';
                case 2:
                    return 'select-blue';
                case 3:
                    return 'select-gray';
                case 4:
                    return 'select-orange';
                case 5:
                    return 'select-red';
                default:
                    return '';
            }
        }
    },
    components: { ClaimChatDropdown, FormDropdown, BaseButton },
};
</script>

<style scoped>
.message-input-container {
    display: flex;
    align-items: center;
    /* margin-top: -10px;
    margin-left: -10px;
    margin-right: -12px;
    margin-bottom: -11px; */
}
.message-input-container > div:first-child {
    border-bottom: 1px solid #eee;
}

.message-input-container > div:first-child > div:not(:last-child){
    border-right: 1px solid #eee;
}

.message-input-dropdown {
    position: relative;
}

.message-input-dropdown:after {
    position: absolute;
    right: 0;
    top: -6px;
    bottom: -6px;
    display: block;
    content: "";
    width: 1px;
    background: #eee;
}

.dark-mode .message-input-dropdown:after{
    background: #6c757d;
}
.dark-mode .message-input-container > div:first-child,
.dark-mode .message-input-container > div:first-child > div:not(:last-child){
    border-color: #6c757d;
}

.message-input-input input {
    border: none;
    padding: 0 10px;
    min-height: 35px;
}

.message-input-button .btn {
    margin: -7px 0;
}

.message-input-button .btn {
    cursor: pointer;
}

@media (max-width: 768px) {
    .message-input-container {
        position: relative;
    }

    .message-input-dropdown:after {
        display: none;
    }

    .message-input-button .btn {
        margin: -7px 0;
        height: 35px;
    }

    .message-input-container .message-input-dropdown {
        padding-right: 10px !important;
    }
}

@media (max-width: 575px) {
    .message-input-container > .row > div:not(:last-child){
        border-bottom: 1px solid #eee;
    }
}
</style>

<style>
.message-input-container .form-control{
    border: none !important;
}
.message-input-container .dropdown-list{
    max-height: 240px;
}
.message-input-input.invalid{
    background: #ffe0e0;
}
.message-input-input input{
    background: transparent;
    background-color: transparent !important;
}

.dark-mode .message-input-input.invalid {
    background: #432e2e;
}
</style>
